import common from './common'
import auth from './auth'

export default {
  ...common,
  auth,
}
